import VideoIframe from '../components/VideoIframe'

export default class ModBannerHome {
  constructor($el) {
    this.$this = $el
    this.$sliderFor = this.$this.find('.slider-for')
    this.$sliderNav = this.$this.find('.slider-nav')
    this.$sliderBg = this.$this.find('.banner-home-background-slider')
  }

  init() {
    if (this.$this.length) {
      this.$this.addClass('is-init')
      this.addSlick()
    }
  }

  addSlick() {
    this.$sliderFor.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      dots: true,
      arrows: true,
      appendArrows: this.$this.find('.arrow-control'),
      appendDots: this.$this.find('.dots-control'),
      prevArrow: '<button class="slick-prev arrows text-primary-300"><span class="icomoon icon-arrow-left pointer-events-none"></span><span class="sr-only">Prev slider</span></button>',
      nextArrow: '<button class="slick-next arrows text-primary-300"><span class="icomoon icon-arrow-right pointer-events-none"></span><span class="sr-only">Next slider</span></button>',
      asNavFor: '.slider-nav',

    })
    this.$sliderNav.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      asNavFor: '.slider-for',
      arrows: false,
      dots: false,
    })
    this.$sliderFor.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      this.$sliderBg.find('.banner-item').removeClass('active').fadeOut()
      this.$sliderBg.find('.banner-item').eq(nextSlide).addClass('active').fadeIn()
    })
    this.$sliderFor.on('afterChange', () => {
      this.autoPlaySlider()
    })
    this.autoPlaySlider()
  }

  autoPlaySlider() {
    this.playVideoSlideActive()
    clearTimeout(this.timeImage)
    if (!this.activeHasVideo()) {
      this.timeImage = setTimeout(() => {
        this.$sliderFor.slick('slickNext')
      }, 5000)
    }
  }

  activeHasVideo() {
    const $active = this.$sliderBg.find('.active')
    const player = $active.data('player')
    return player.type !== null
  }

  setupVideo($slider, play = true) {
    if ($slider.data('player')) {
      const player = $slider.data('player')
      if (player.type !== null) {
        if (play) {
          player.playVideo()
        } else {
          player.pauseVideo()
        }
      }
      return
    }

    if (play) {
      const player = new VideoIframe($slider, this.$sliderBg, this.$sliderFor)
      $slider.data('player', player)
      if (player.type !== null) {
        player.init()
      }
    }
  }

  playVideoSlideActive() {
    // if (window.innerWidth < 768) {
    //   return
    // }
    this.$sliderBg.find('.banner-item').each((_index, element) => {
      this.setupVideo($(element), $(element).hasClass('active'))
    })
  }
}
$('.js-banner-home').each((_i, e) => {
  new ModBannerHome($(e)).init()
})
